
import { useContext } from "react";
import { Link } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import { textes } from "../../constants/textes";


export default function Pubr({pub, position}) {
    // states
    const {user} = useContext(UserContext);


    // comportements


    // Affichage
    return (
        <tr style={{borderStyle: "none"}}>
            <td className="text-center">{position + 1}</td>
            <td>
                <div className="d-flex flex-row">
                    <div className="widget-content-left mr-3">
                        <img style={{width: 48, height: 48}} className="rounded" src={pub.photo !== null ? pub?.photo : "/assets/imgs/blank.png"} alt="" />
                    </div>
                    <div className="widget-content-left">
                        <div className="widget-heading">{pub?.nomuser}</div>
                        <div className="widget-subheading">{pub?.email}</div>
                    </div>
                </div>
            </td>
            <td><img style={{width: 72}} className="rounded" src={pub.img !== null ? pub?.img : "/assets/imgs/no-image.png"} alt="" /></td>
            {/* <td>{pub?.lib}</td> */}
            {/* <td>{pub?.prix}</td> */}
            <td>{pub.duree !== null ? pub?.duree : ""}</td>
            <td>{pub?.datedeb !== null ? pub?.datedeb.slice(0, 16).replace("T", " à ") : ""}</td>
            <td>{pub?.datelim !== null ? pub?.datelim.slice(0, 16).replace("T", " à ") : ""}</td>
            <td>
                <span 
                    className={`badge ${
                        pub.etat === 1 ? "badge-success" : 
                        pub.etat === 2 ? "badge-warning" : 
                        pub.etat === 3 ? "badge-danger" : 
                        ""
                        } mt-2`
                    } 
                    style={{fontSize: 14}}>
                        {
                            pub.etatdef !== null ? pub?.etatdef : 
                            "Etat"
                        }
                </span>
            </td>
            <td>{pub?.datecrea.slice(0, 16).replace("T", " à ")}</td>
            <td className="text-center">
                {(user?.isFullAction || user?.isAdminAction || user?.isConsulterPublicite) && 
                    <Link to={`/pub/${pub?.code}`} data-toggle="tooltip" title={textes.fr.viewpublicitelabel} data-placement="left" className="btn-shadow-primary mr-2 ml-2 btn btn-sm btn-primary">
                        <i className="fa fa-eye"></i>
                    </Link>
                }
            </td>
        </tr>
    )
}